import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Switch } from 'react-router-dom';
import { PublicRoute } from '@marvelapp/ballpark-application';
import { NotFound } from './ErrorPages';
export function SwitchWithNotFound({ errorComponent = NotFound, children, }) {
    return (_jsxs(Switch, { children: [children, _jsx(PublicRoute, { component: errorComponent })] }));
}
